import React, { Component } from "react";
import { PersonConsent } from "../shared/PersonConsent";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  updateContactPreferences,
  contactPreferenceInternalView,
  setDeepLinkingUrl
} from "../../actions/policy/policyActions";
import styles from "../../assets/css/modules/policies/gdpr.css";
import { Paths } from "../../constants/UrlConstants";
import InternalViewButton from "../shared/buttons/InternalViewButton";
import SSOContainer from "../shared/containers/SSOContainer";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import { Layouts } from "../../constants/Constants";
import { availableVariationTypes } from "../../content/GDPR";
import contactPreferenceStyles from "../../assets/css/modules/preference/contact-preferences.css";
import MfaMarkettingSsoContainers from "../shared/containers/MfaMarkettingSsoContainers";
import InternalViewButtonMfa from "../shared/buttons/internalViewButtonMfa";

export const mapStateToGDPR = (state, props) => {
  const { policyReducer, accountReducer, layoutReducer,onboardingReducer } = { ...state };
  const isInternalView =
    policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView;

  return {
    onboardingFlag :onboardingReducer.isUserOnboarding,
    MembershipNumber:
      policyReducer &&
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.MembershipNumber,
    PersonConsent:
      policyReducer &&
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.PersonConsent,
    HasMultiplePolicies:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.HasMultiplePolicies,
    isInternalView,
    contentVariationType:
      layoutReducer && layoutReducer.layout === Layouts.HOL
        ? availableVariationTypes.HOL
        : availableVariationTypes.Any,
    deeplinkingUrl: accountReducer && accountReducer.deeplinkingUrl,
    ...props
  };
};

export class GDPR extends Component {
  constructor(props) {
    super(props);
    var consent = Object.assign({}, this.props.PersonConsent);
    this.state = {
      PersonConsent: consent,
      shownErrors: []
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onSkipClick = this.onSkipClick.bind(this);
    this.validatePersonConsent = this.validatePersonConsent.bind(this);
  }

  onSkipClick(e) {
    if (this.props.isInternalView) {
      e.preventDefault();
      var consent = Object.assign({}, this.props.PersonConsent);
      this.setState({
        PersonConsent: consent
      });

      this.props.contactPreferenceInternalView();
      this.props.history.push(Paths.HomeRoot);
    }
  }

  validatePersonConsent(personConsent) {
    let errorMessages = [];
    if (personConsent.Email === null) {
      errorMessages.push(Store.GDPR.ValidationErrors.InvalidPersonConsentEmail);
    }
    if (personConsent.Telephone === null) {
      errorMessages.push(
        Store.GDPR.ValidationErrors.InvalidPersonConsentTelephone
      );
    }
    if (personConsent.Post === null) {
      errorMessages.push(Store.GDPR.ValidationErrors.InvalidPersonConsentPost);
    }
    if (personConsent.Sms === null) {
      errorMessages.push(Store.GDPR.ValidationErrors.InvalidPersonConsentSms);
    }
    return errorMessages;
  }

  onSubmit = async (e) => {
    e.preventDefault();
    var errors = this.validatePersonConsent(this.state.PersonConsent);
    if (errors.length > 0) {
      this.setState({ shownErrors: errors });
    } else {
      try {
        if (this.props.deeplinkingUrl === Paths.PersonConsent) {   
          if(this.props.onboardingFlag){
            await this.props.setDeepLinkingUrl(Paths.DocumentPreference);
          }
          else{
            await this.props.setDeepLinkingUrl(null);
          }
        }
        this.props.updateContactPreferences(
          this.props.MembershipNumber,
          this.state.PersonConsent,
          this.props.history
        );
        

      }  catch (e) {
        this.setState({
          shownErrors: [Store.GDPR.ValidationErrors.ServerError]
        });
      }
    }
  };

  render() {
    return (
      window?.axa?.features?.MFAFeature === "true"?
      <MfaMarkettingSsoContainers mfa={true}>
        <div className={contactPreferenceStyles.contactPreferences}>
          <h1 className={`axa-headline ${contactPreferenceStyles.marketingMfaTitle}`}>
            {Store.GDPR.Heading}
          </h1>
          <div className={styles.gdprSectionMfa}>
            {this.state.shownErrors.length > 0 ? (
              <div className="alert alert-danger" role="alert">
                <p className="alert-heading mb-1">
                  {
                    <strong>
                      <Content
                        name={Store.GDPR.ValidationErrors.CorrectErrors}
                      />
                    </strong>
                  }
                </p>
                <ul className="mb-0 pl-4">
                  {this.state.shownErrors.map((e) => (
                    <li key={e}>
                      <Content name={e} />
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          {getContentByVariationType(
            this.props.contentVariationType,
            Store.GDPR.Description
          )}
          <div className={styles.gdprSectionMfa}>
            {this.state.PersonConsent ? (
              <div className={contactPreferenceStyles.personConsent}>
                <PersonConsent
                  PersonConsent={this.state.PersonConsent}
                  updateConsent={(consent) =>
                    this.setState({ PersonConsent: consent })
                  }
                />
              </div>
            ) : null}
          </div>
          <div>
            {getContentByVariationType(
              this.props.contentVariationType,
              Store.GDPR.Notice
            )}
          </div>
          <div>
            <form onSubmit={this.onSubmit}>
              <div>
                {this.props.HasMultiplePolicies ? (
                  <p className="axa-body-text-4 mt-2">
                    <Link to={Paths.ChooseYourPlan}>
                      <span className="mr-2 left-arrow-back">←</span>{" "}
                      {Store.GDPR.ButtonBack}
                    </Link>
                  </p>
                ) : null}
              </div>
              <div>
                <InternalViewButtonMfa
                  type="submit"
                  className="form-control btn btn-submit"
                  label={Store.GDPR.ButtonContinue}
                />
                {this.props.isInternalView ? (
                  <p className="axa-body-text-4 mt-2">
                    <Link
                      to="#"
                      onClick={(e) => this.onSkipClick(e)}
                      id="lnk-Skip"
                    >
                      Skip
                      <span className="mr-2 left-arrow-back">&#8594;</span>{" "}
                    </Link>
                  </p>
                ) : null}
              </div>
            </form>
          </div>
        </div>
      </MfaMarkettingSsoContainers>
      :
            <SSOContainer>
        <div className={contactPreferenceStyles.contactPreferences}>
          <h1 className={`axa-headline ${contactPreferenceStyles.title}`}>
            {Store.GDPR.Heading}
          </h1>
          <div className={styles.gdprSection}>
            {this.state.shownErrors.length > 0 ? (
              <div className="alert alert-danger" role="alert">
                <p className="alert-heading mb-1">
                  {
                    <strong>
                      <Content
                        name={Store.GDPR.ValidationErrors.CorrectErrors}
                      />
                    </strong>
                  }
                </p>
                <ul className="mb-0 pl-4">
                  {this.state.shownErrors.map((e) => (
                    <li key={e}>
                      <Content name={e} />
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          {getContentByVariationType(
            this.props.contentVariationType,
            Store.GDPR.Description
          )}
          <div className={styles.gdprSection}>
            {this.state.PersonConsent ? (
              <div className={contactPreferenceStyles.personConsent}>
                <PersonConsent
                  PersonConsent={this.state.PersonConsent}
                  updateConsent={(consent) =>
                    this.setState({ PersonConsent: consent })
                  }
                />
              </div>
            ) : null}
          </div>
          <div>
            {getContentByVariationType(
              this.props.contentVariationType,
              Store.GDPR.Notice
            )}
          </div>
          <div>
            <form onSubmit={this.onSubmit}>
              <div>
                {this.props.HasMultiplePolicies ? (
                  <p className="axa-body-text-4 mt-2">
                    <Link to={Paths.ChooseYourPlan}>
                      <span className="mr-2 left-arrow-back">←</span>{" "}
                      {Store.GDPR.ButtonBack}
                    </Link>
                  </p>
                ) : null}
              </div>
              <div>
                <InternalViewButton
                  type="submit"
                  className="form-control btn btn-submit"
                  label={Store.GDPR.ButtonContinue}
                />
                {this.props.isInternalView ? (
                  <p className="axa-body-text-4 mt-2">
                    <Link
                      to="#"
                      onClick={(e) => this.onSkipClick(e)}
                      id="lnk-Skip"
                    >
                      Skip
                      <span className="mr-2 left-arrow-back">&#8594;</span>{" "}
                    </Link>
                  </p>
                ) : null}
              </div>
            </form>
          </div>
        </div>
      </SSOContainer>
    );
  }
}

export default withRouter(
  connect(mapStateToGDPR, {
    updateContactPreferences,
    contactPreferenceInternalView,
    setDeepLinkingUrl
  })(GDPR)
);
